// extracted by mini-css-extract-plugin
export default {"primaryButton":"primaryButton_primaryButton__12QxS"};